import React, { Component } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { FlowData, GeneralVerify } from "./sopDataTemplate";
import Select from "react-select";

interface AllProps {
  data: FlowData;
  handleFlowChange: any;
  isOnlyView?: boolean;
}
export class Flow extends Component<AllProps> {
  state = {
    isOptionOpen: false,
    bgColor: "#ffff8d",
    responseData: {},
  };

  componentDidMount() {
    const { data } = this.props;
    this.setState({
      responseData: JSON.parse(JSON.stringify(data)),
    });
  }

  changeBgColor = () => {
    const { bgColor } = this.state;
    if (bgColor !== "lightgreen") {
      this.setState({ bgColor: "lightgreen" });
    }
  };
  handleChange = (name, val) => {
    const { data } = this.props;
    data[name] = val;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleFlowChange(data);
  };
  handleStateChange = (stateName, value) => {
    console.log("value", value);
    this.setState(
      {
        [stateName]: value,
      },
      () => {
        this.changeBgColor();
      }
    );
  };
  handleFileChange = (name, val) => {
    const { data } = this.props;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleFlowChange(data);
  };
  getOtherProps = (key) => {
    // const { data, isOnlyView } = this.props;
    // if (isOnlyView) return { [key]: true };
    return null;
  };

  handleChildInputChange = (key, name, value, index?) => {
    const { data } = this.props;
    if (index !== undefined) data[key][index][name] = value;
    else data[key][name] = value;
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleFlowChange(data);
  };
  handleChildRadioChange = (key, name, val, index?) => {
    const { data } = this.props;
    if (index !== undefined) {
      data[key][index][name] = val;
    } else {
      data[key][name] = val;
    }
    this.changeBgColor();
    data.bgColor = "lightgreen";
    this.props.handleFlowChange(data);
  };

  addChild = (type) => {
    const { data } = this.props;

    // Create a copy of data or initialize a new object
    const updatedData = data ? { ...data } : {};

    // Ensure the type property exists as an array
    if (!updatedData[type] || !Array.isArray(updatedData[type])) {
      updatedData[type] = [];
    }

    // Add new child object to the correct array (updatedData, not data)
    updatedData[type].push({
      specialTahsildar: false,
      boundaryCertificate: false,
      roadApproach: false,
    });

    // Update parent component
    this.props.handleFlowChange(updatedData);
  };

  removeChild = (type, index) => {
    const { data } = this.props;
    delete data[type][index];
    const updatedLegalHeirs = data[type].filter((item) => item !== null);
    data[type] = updatedLegalHeirs;
    this.props.handleFlowChange(data);
  };

getAddButton = (title: string, value: string, showRadioForSection?: boolean) => {
    const { data } = this.props;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <h6 style={{ margin: 0 }}>
                    <b>{title}</b>
                </h6>

                {/* Show radio buttons only for the specified section */}
                {showRadioForSection === true && (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "20px",
                        }}
                    >
                        <Form.Check
                            inline
                            label="Yes"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-yes`}
                            checked={data[`isshow${value}Status`] === true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = true;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handleFlowChange(data);
                            }}
                            style={{ marginRight: "15px" }}
                        />
                        <Form.Check
                            inline
                            label="No"
                            name={`isshow${value}Status`}
                            type="radio"
                            id={`isshow${value}Status-no`}
                            checked={data[`isshow${value}Status`] !== true}
                            onChange={() => {
                                const fieldName = `isshow${value}Status`;
                                data[fieldName] = false;
                                this.changeBgColor();
                                data.bgColor = "lightgreen";
                                this.props.handleFlowChange(data);
                            }}
                        />
                    </div>
                )}
            </div>

            <div onClick={() => this.addChild(value)}>
                <button
                    className="btn btn-sm btn-primary"
                    style={{ fontSize: "smaller" }}
                >
                    Add {title}
                </button>
            </div>
        </div>
    );
};
  checkOperation = (type, value, index) => {
    let isEditable = false;
    const { responseData } = this.state;
    if (responseData[type] && responseData[type].length < index + 1) {
      isEditable = true;
    }
    return isEditable;
  };

  render() {
    const { data, isOnlyView } = this.props;
    const { isOptionOpen, bgColor } = this.state;
    return (
      <div className="collapse-section count-doc-verify">
        <Accordion>
          <Card>
            <Accordion.Toggle
              style={{ background: data?.bgColor ? data?.bgColor : bgColor }}
              as={Card.Header}
              eventKey="8"
              onClick={() => {
                this.setState({ isOptionOpen: !isOptionOpen });
              }}
            >
              <h5>
                <b>Flow</b>
              </h5>
              <i
                className={`icon feather icon-${
                  !isOptionOpen ? "plus" : "minus"
                }`}
                style={{
                  color: "black",
                  fontSize: "17px",
                  fontWeight: "bold",
                  float: "right",
                }}
              />
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                <div>
                  {this.getAddButton("Flow", "flow",true)}
                  {data?.flow &&
                    Array.isArray(data?.flow) &&
                    data?.flow.map((value, index) => {
                      return (
                        <>
                          <div className="row mb-10" key={index}>
                            <div className="col-md-4 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                Chainlink is in Order- Favour and Excecutant is
                                in flow
                              </label>
                              {/* {data.file.btTransfer}/ */}
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "Chainlink" +
                                    (value && value.Chainlink
                                      ? value.Chainlink
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.Chainlink}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "Chainlink",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "Chainlink" +
                                    (value && !value.Chainlink
                                      ? !value.Chainlink
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.Chainlink}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "Chainlink",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                In flow ,document holder expired means Legal
                                Heir Certificate available
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "inFlowdoc" +
                                    (value && value.inFlowdoc
                                      ? value.inFlowdoc
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.inFlowdoc}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "inFlowdoc",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "inFlowdoc" +
                                    (value && !value.inFlowdoc
                                      ? !value.inFlowdoc
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.inFlowdoc}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "inFlowdoc",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                All the Legal Heirs signed in the next document
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "legalHeirsSigndoc" +
                                    (value && value.legalHeirsSigndoc
                                      ? value.legalHeirsSigndoc
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.legalHeirsSigndoc}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "legalHeirsSigndoc",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "legalHeirsSigndoc" +
                                    (value && !value.legalHeirsSigndoc
                                      ? !value.legalHeirsSigndoc
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.legalHeirsSigndoc}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "legalHeirsSigndoc",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                In flow , Court order comes -Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "courtOrderVerify" +
                                    (value && value.courtOrderVerify
                                      ? value.courtOrderVerify
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.courtOrderVerify}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "courtOrderVerify",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "courtOrderVerify" +
                                    (value && !value.courtOrderVerify
                                      ? !value.courtOrderVerify
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.courtOrderVerify}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "courtOrderVerify",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                In flow, POA Verified
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "flowPoAVerfy" +
                                    (value && value.flowPoAVerfy
                                      ? value.flowPoAVerfy
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.flowPoAVerfy}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowPoAVerfy",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "flowPoAVerfy" +
                                    (value && !value.flowPoAVerfy
                                      ? !value.flowPoAVerfy
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.flowPoAVerfy}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowPoAVerfy",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                In flow Extent compare with the origin document
                                to title deed
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "flowextentDeed" +
                                    (value && value.flowextentDeed
                                      ? value.flowextentDeed
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.flowextentDeed}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowextentDeed",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "flowextentDeed" +
                                    (value && !value.flowextentDeed
                                      ? !value.flowextentDeed
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.flowextentDeed}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowextentDeed",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-md-3 mb-10">
                              <label
                                className="label mb-2"
                                style={{ padding: 0 }}
                              >
                                In flow Survey Number compare with the origin
                                document to title deed
                              </label>
                              <div className="row" style={{ marginLeft: 0 }}>
                                <Form.Check
                                  inline
                                  label="Yes"
                                  name={
                                    "flowSurveynoDeed" +
                                    (value && value.flowSurveynoDeed
                                      ? value.flowSurveynoDeed
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={value.flowSurveynoDeed}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowSurveynoDeed",
                                      true,
                                      index
                                    )
                                  }
                                />
                                <Form.Check
                                  inline
                                  label="No"
                                  name={
                                    "flowSurveynoDeed" +
                                    (value && !value.flowSurveynoDeed
                                      ? !value.flowSurveynoDeed
                                      : "") +
                                    index
                                  }
                                  type="radio"
                                  checked={!value.flowSurveynoDeed}
                                  onChange={() =>
                                    this.handleChildRadioChange(
                                      "flow",
                                      "flowSurveynoDeed",
                                      false,
                                      index
                                    )
                                  }
                                />
                              </div>
                            </div>
                            {this.checkOperation("flow", value, index) && (
                              <div
                                className="form-group col-md-2"
                                style={{
                                  alignSelf: "center",
                                  fontSize: "initial",
                                  cursor: "pointer",
                                }}
                                onClick={() => this.removeChild("flow", index)}
                              >
                                <i
                                  style={{ color: "red" }}
                                  className="feather icon-minus-circle"
                                />
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    );
  }
}

export default Flow;
